import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  radioButton: "S",
};

const radioButtonSlice = createSlice({
  name: "radioButton",
  initialState,
  reducers: {
    setRadioButton: (state, action) => {
      state.radioButton = action.payload;
    },
    deleteRadioButton: (state) => {
      state.radioButton = "";
    },
  },
});

export const { setRadioButton, deleteRadioButton } = radioButtonSlice.actions;
export default radioButtonSlice.reducer;
